import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { AccessDenied } from 'shared/errors/access-denied'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { useCommentsCount } from 'modules/community/api/get-comments-count'
import { PostAnnounceSkeleton } from 'modules/community/components/post-announce/components/post-announce-skeleton'
import PostDetails from 'modules/community/components/post/post-details'
import { usePost } from 'modules/community/post/hooks/use-post'

const Post = () => {
  const router = useRouter()
  const { communityPath, topicPath, postPath } = router.query

  const {
    data: post,
    mutate,
    error,
    isValidating,
  } = usePost({
    communityPath: communityPath as string,
    topicPath: topicPath as string,
    postPath: postPath as string,
  })

  useCommentsCount({
    communityPath: communityPath as string,
    postsIds: post?.id ? [post?.id] : undefined,
    config: {
      onSuccess: data => {
        mutate(post => post && { ...post, commentsCount: data[0]?.commentsCount }, false)
      },
    },
  })

  useEffect(() => {
    if (error && error instanceof AccessDenied) {
      router.push(`/community/${communityPath}`)
    }
  }, [error, communityPath, router])

  if (!post || isValidating) {
    return <PostAnnounceSkeleton />
  }

  return <PostDetails post={post} mutatePost={mutate} />
}

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default Post
